<template>
    <div class="container-01">
        <h2>SKILLS</h2>
        <ul class="container-02">
            <li v-for="item in skills" :key="item.hash" class="container-04">
                <p class="body">{{ item.type }}:</p>
                <p>
                    <span class="caption">{{ item.primary.join(", ") }}</span>
                    <span class="summary">{{ item.secondary.length ? ", " : "" }} {{ item.secondary.join(", ") }}</span>
                </p>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import {  Skills } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "skills",
    props: {
        skills: {
            type: Skills,
            required: true
        } 
    }
})
</script>

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

li 
   text-indent: 0
   list-style-type: none
</style>